import { createComponent } from '@carvana/merch-components';
import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

const Svg = createComponent<OwnProps>('svg', {
  className: '-:h-[16px] -:w-[16px]'
});

const DownArrowIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <Svg viewBox="0 0 16 16" ref={ref} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 6H13.5L8.5 11.5L3.5 6Z"
      fill="#00AED9"
    />
  </Svg>
));

export default DownArrowIcon;
